export type evtTypes =
  | 'pageView'
  | 'gameStart'
  | 'maxScore'
  | 'notMaxScore'
  | 'questionOK'
  | 'questionKO'
  | 'questionTo'
  | 'socialShare'
  | 'friendChallenge'
  | 'playAgain'
  | 'loquisNotSkipped'
  | 'loquisSkipped'
  | 'googlePlayCTA'
  | 'loquisPlay'
  | 'appStoreCTA';

const _evt = {
  pageView: 'pageView',
  questionTo: 'QUESTION_TIMEOUT',
  questionKO: 'QUESTION_KO',
  questionOK: 'QUESTION_OK',
  loquisNotSkipped: 'LOQUIS_NOT_SKIPPED',
  loquisSkipped: 'LOQUIS_SKIPPED',
  maxScore: 'MAX_SCORE',
  notMaxScore: 'NOT_MAX_SCORE',
  socialShare: 'SOCIAL_SHARE',
  friendChallenge: 'FRIEND_CHALLENGE',
  playAgain: 'PLAY_AGAIN',
  gameStart: 'GAME_START',
  appStoreCTA: 'APP_STORE_CTA',
  googlePlayCTA: 'GOOGLE_PLAY_CTA',
  loquisPlay: 'LOQUIS_PLAY',
};

const config = {} as any;

export function configDataLayer(lng: string = null, inst: string = null, preset: string = null) {
  config.lng = lng;
  config.inst = inst;
  config.preset = preset;
}

export function pushGtmDataLayer(evt: evtTypes, category?: any, label?: any) {
  const event = `${_evt[evt]}:${config.lng}:${config.inst}:${config.preset}`;
  window.dataLayer.push({ event, category, label });
  // console.log('GTM dl', _evt[evt], 'tracked');
}
